import { environment } from "environments/environment";

export const freshDeskApiSettings = {
    freshDeskUrlApi: environment.freshDeskUrlApi,
    freshDeskApiKey: environment.freshDeskApiKey,
}